<script>
    import { navigate } from "../router";
    import { getUser } from "../user.js";
    import { AGE_LABEL } from "../dico.js";
    import { sneakPeek } from "../utils.js";
    import { onMount } from "svelte";
    import { writable } from "svelte/store";
    import { Background } from "../component/modifier";
    import { HStack, VStack, Spacer } from "../component/layout";
    import { Button, Label, Icon, Hamburger } from "../component/widget";
    import CookieConsent from "../component/CookieConsent.svelte";
    import Header from "../component/Header.svelte";
    import Copyright from "../component/Copyright.svelte";
    import GuestForm from "../component/GuestForm.svelte";
    import GuestLabels from "../component/GuestLabels.svelte";

    import { load, loadRsvp, update, deleteRsvp } from "../rsvp.js";
    import {
        loadGroupFromInvitationCode as loadGroup,
        add,
    } from "../guest.js";
    import { loadAll as loadLabels, loadGuest, loadInvitation } from "../labels.js";

    export let wedding_guid;

    let isTrash = false;
    let isInBox = false;
    let isArchive = false;

    function showInBox() {
        isInBox = true;
        isTrash = false;
        isArchive = false;
    }

    function showArchive() {
        isArchive = true;
        isInBox = false;
        isTrash = false;
    }

    function showTrash() {
        isTrash = true;
        isArchive = false;
        isInBox = false;
    }

    let messages = writable([]);
    let message_id;
    let message = writable(undefined);
    let invitation = writable([]);

    let labels;
    let isAddGuest = false;
    let guestId = null;
    let firstName = null;
    let lastName = null;
    let email = null;
    let age = "A";
    let gender = "F";
    let attending = null;
    let food_restriction = null;
    let favorite_songs = null;
    let age_val = null;

    let labels_guests;
    let labels_invitations;

    let messageHamburgers;

    let hamburger;
    function cookHamburgers(group) {
        if (group) {
            let h = [];
            h.push({ display: false, opened: false });
            for (const g of group) {
                h.push({ display: false, opened: false });
            }
            hamburger = h;
        }
    }

    $: cookHamburgers($invitation);

    function loadMessage(id) {
        if (id) {
            loadRsvp(wedding_guid, id).then((guests) => {
                let mes = $messages.find((m) => m.id == id);
                message.set({ m: mes, g: guests });
                if (mes.invitation_code) {
                    loadGroup(wedding_guid, mes.invitation_code).then(async (r) => {
                        await loadLabelsForInvitation(r);
                        invitation.set(r);
                    });
                } else {
                    invitation.set([]);
                }
            });
        } else {
            message.set(undefined);
            invitation.set([]);
        }
    }

    $: loadMessage(message_id);

    //$: console.log(message_id);

    function getTooltipAge(g) {
        return `${AGE_LABEL[g.age]}` + (g.age_val ? ` (${g.age_val} ans)` : "");
    }

    const loadLabelsForInvitation = async (invitation) => {
        invitation[0].groupLabels = await loadInvitation(invitation[0].invitation_id);
        for (const guest of invitation) {
            guest.labels = await loadGuest(guest.id);
        }
    };

    const handleInvitationLabels = (e, invitation_id) => {
        e.stopPropagation();
        handleLabels(invitation_id, 0, false);
    };

    const handleLabels = (guest_id, i, isGuest = true) => {
        labels = new GuestLabels({
            target: document.querySelector("body"),
            props: {
                guestId: guest_id,
                isGuest: isGuest,
            },
        });
        const off = labels.$on("close", (event) => {
            off();
            labels.$destroy();
        });

        labels.$on("refresh", async (event) => {
            let i = $invitation;
            await loadLabelsForInvitation(i);
            invitation.set(i);
        });
        hamburger[i].opened = false;
    };

    const submit = async (
        firstname,
        lastname,
        email,
        age,
        gender,
        guestId,
        attending,
        food_restriction,
        favorite_songs,
        age_val
    ) => {
        await add(
            wedding_guid,
            $invitation[0].invitation_id,
            guestId,
            firstname,
            lastname,
            email,
            age,
            gender,
            attending,
            food_restriction,
            favorite_songs,
            age_val
        );
        isAddGuest = false;
        loadGroup(wedding_guid, $invitation[0].code).then(async (r) => {
            await loadLabelsForInvitation(r);
            invitation.set(r);
        });
    };

    const cancel = () => {
        isAddGuest = false;
    };

    const addGuest = () => {
        firstName = null;
        lastName = $invitation[0].lastname;
        email = null;
        age = "A";
        gender = "F";
        attending = null;
        food_restriction = null;
        favorite_songs = null;
        guestId = null;
        isAddGuest = true;
        age_val = null;
    };

    const editGuest = (guest_id, i) => {
        let g = $invitation.find((g) => g.id == guest_id);
        firstName = g.firstname;
        lastName = g.lastname;
        email = g.email;
        age = g.age;
        gender = g.gender;
        guestId = g.id;
        attending = g.is_attending === "1" ? "O" : "N";
        food_restriction = g.food_restriction;
        favorite_songs = g.favorite_songs;
        age_val = g.age_val;
        isAddGuest = true;
        hamburger[i].opened = false;
    };

    const refresh = async () => {
        await $userRequest;
        let mailbox = isInBox ? "INBOX" : isArchive ? "ARCHIVE" : isTrash ? "TRASH" : undefined;
        console.log("refreshing mailbox", mailbox);
        if (mailbox === undefined) return;

        try {
            load(wedding_guid, mailbox)
                .then((r) => {
                    messages.set(r);
                    if (r.length > 0) {
                        message_id = r[0].id;
                    } else {
                        message_id = null;
                    }
                    let h = [];
                    for (const m of r) {
                        h.push({ display: false, opened: false });
                    }
                    messageHamburgers = h;
                })
                .catch((e) => {
                    console.log(e);
                    messages.set([]);
                });
        } catch (e) {
            console.log(e);
        }
    };

    const refreshLabels = async () => {
        loadLabels(wedding_guid).then((r) => {
            labels_guests = r.data;
        });

        loadLabels(wedding_guid, true).then((r) => {
            labels_invitations = r.data;
        });

        isInBox = true;
    };

    const onMessage = (m) => {
        message_id = m.id;
        if (m.is_read !== "1") {
            update(wedding_guid, m.id, true).then(() => {
                m.is_read = "1";
                messages.set($messages);
            });
        }
    };

    const archive = async (m, i) => {
        await update(wedding_guid, m.id, undefined, m.folder === "ARCHIVE" ? "INBOX" : "ARCHIVE");
        refresh();
    };

    const trash = async (m, i) => {
        if (m.folder === "TRASH") {
            await deleteRsvp(wedding_guid, m.id);
        } else {
            await update(wedding_guid, m.id, undefined, "TRASH");
        }

        refresh();
    };

    $: refresh(isArchive, isInBox, isTrash);

    let userRequest;

    onMount(() => {

        console.log("Rsvp on mount");

        userRequest = getUser();

        const unsubscribe = userRequest.subscribe((promise) => {
            promise.then(refreshLabels).catch((e) => {
                navigate("/");
            });
        });

        return () => {
            console.log("Rsvp destroy");
            unsubscribe();
        };

    });
</script>

<main>
    <CookieConsent />
    <Header>
        <div slot="left">
            <Button action={() => navigate(`#/dashboard/${wedding_guid}`)}>
                <Label text="Dashboard" icon="tachometer-alt" borderLeft h="48px" />
            </Button>
        </div>
    </Header>
    <Background color="var(--primary-color)">
        <HStack grow alignment="stretch">
            <side>
                <h2>Messages</h2>
                <section>
                    <Icon
                        name="inbox"
                        size="48"
                        selected={isInBox}
                        on:click={showInBox}
                        cursor="pointer" />
                    <Icon
                        name="archive"
                        size="48"
                        selected={isArchive}
                        on:click={showArchive}
                        cursor="pointer" />

                    <Icon
                        name="trash-alt"
                        size="48"
                        selected={isTrash}
                        on:click={showTrash}
                        cursor="pointer" />
                </section>
                <div>
                    <VStack alignment="stretch">
                        {#each $messages as m, i (m.id)}
                            <article
                                on:mouseenter={() => (messageHamburgers[i].display = true)}
                                on:mouseleave={() => (messageHamburgers[i].display = false)}
                                on:click={() => onMessage(m)}
                                class:read={m.is_read === "1"}
                                class:selected={m.id == message_id}>
                                <VStack grow justify="center">
                                    <HStack alignment="baseline">
                                        <span class="from">{`[${m.type}] ${m.nickname}`}</span>
                                        <Spacer />
                                        <span class="date">{m.created_at}</span>
                                    </HStack>
                                    {#if m.comment}
                                        <span class="comment">{sneakPeek(m.comment, 40)}</span>
                                    {/if}
                                </VStack>
                                <Spacer />
                                <Hamburger
                                    left={false}
                                    bind:open={messageHamburgers[i].opened}
                                    display={messageHamburgers[i].display}>
                                    <Button action={() => archive(m, i)}>
                                        <Label
                                            text={m.folder == "ARCHIVE"
                                                ? "Désarchiver"
                                                : "Archiver"}
                                            icon="edit"
                                            h="24px" />
                                    </Button>
                                    <Button action={() => trash(m, i)}>
                                        <Label text="Supprimer" icon="times-circle" h="24px" />
                                    </Button>
                                </Hamburger>
                            </article>
                        {/each}
                        <article />
                    </VStack>
                </div>
            </side>
            <content>
                {#if $message}
                    <section>
                        <HStack>
                            <img src="/images/ic_coeurVertx4.png" alt="RSVP" width="48px" />
                            <VStack grow>
                                <HStack alignment="baseline">
                                    <span class="from">
                                        {`[${$message.m.type}] ${$message.m.nickname} <${$message.m.login}>`}</span>
                                    <Spacer />
                                    <span class="date">{$message.m.created_at}</span>
                                </HStack>
                                {#if $message.m.comment}
                                    <span class="comment">{sneakPeek($message.m.comment, 40)}</span>
                                {/if}
                            </VStack>
                        </HStack>
                    </section>
                    <article>
                        <VStack>
                            {#if $message.m.type == "RSVP"}
                                <p>
                                    <HStack>
                                        <span>Présent à la soirée de mariage:</span>
                                        <span
                                            class="label"
                                            class:attending={$message.m.is_attending === "1"}
                                            class:not_attending={$message.m.is_attending === "0"}>
                                            <Label
                                                text={$message.m.is_attending === "1"
                                                    ? "OUI"
                                                    : "NON"}
                                                tooltip={$message.m.is_attending === "1"
                                                    ? "Présent"
                                                    : "Non présent"} />
                                        </span>
                                    </HStack>
                                    <HStack>
                                        <span>Présent au brunch:</span>
                                        <span
                                            class="label"
                                            class:attending={$message.m.is_attending_1 === "1"}
                                            class:not_attending={$message.m.is_attending_1 === "0"}>
                                            <Label
                                                text={$message.m.is_attending_1 === "1"
                                                    ? "OUI"
                                                    : "NON"}
                                                tooltip={$message.m.is_attending_1 === "1"
                                                    ? "Présent"
                                                    : "Non présent"} />
                                        </span>
                                    </HStack>
                                    {#if $message.m.is_attending === "1"}
                                        Serons présents au dîner :
                                    {:else}
                                        Ne serons pas présents au dîner :
                                    {/if}
                                    {#each $message.g as g, i}
                                        <Button action={() => (g.opened = !g.opened)}>
                                            <section class="member" class:opened={g.opened}>
                                                <HStack alignment="flex-start" grow>
                                                    <span class="name">
                                                        {#if g.age == "A"}
                                                            {#if g.gender == "F"}
                                                                <Label
                                                                    text="{g.firstname}
                        {g.lastname}"
                                                                    nowrap
                                                                    size="18"
                                                                    icon="female"
                                                                    iconColor="#FF005C" />
                                                            {:else}
                                                                <Label
                                                                    text="{g.firstname}
                        {g.lastname}"
                                                                    nowrap
                                                                    size="18"
                                                                    icon="male" />
                                                            {/if}
                                                        {:else if g.age == "T"}
                                                            {#if g.gender == "F"}
                                                                <Label
                                                                    text="{g.firstname}
                        {g.lastname}"
                                                                    nowrap
                                                                    size="18"
                                                                    fa={false}
                                                                    icon="images/cap_pink.svg"
                                                                    iconColor="#FF005C" />
                                                            {:else}
                                                                <Label
                                                                    text="{g.firstname}
                        {g.lastname}"
                                                                    nowrap
                                                                    size="18"
                                                                    fa={false}
                                                                    icon="images/cap.svg" />
                                                            {/if}
                                                        {:else if g.age == "C"}
                                                            {#if g.gender == "F"}
                                                                <Label
                                                                    text="{g.firstname}
                        {g.lastname}"
                                                                    nowrap
                                                                    size="18"
                                                                    icon="child"
                                                                    iconColor="#FF005C" />
                                                            {:else}
                                                                <Label
                                                                    text="{g.firstname}
                        {g.lastname}"
                                                                    nowrap
                                                                    size="18"
                                                                    icon="child" />
                                                            {/if}
                                                        {:else if g.age == "B"}
                                                            {#if g.gender == "F"}
                                                                <Label
                                                                    text="{g.firstname}
                        {g.lastname}"
                                                                    nowrap
                                                                    size="18"
                                                                    icon="baby"
                                                                    iconColor="#FF005C" />
                                                            {:else}
                                                                <Label
                                                                    text="{g.firstname}
                        {g.lastname}"
                                                                    nowrap
                                                                    size="18"
                                                                    icon="baby" />
                                                            {/if}
                                                        {/if}
                                                    </span>
                                                    <span class="age">
                                                        <Label
                                                            text={AGE_LABEL[g.age]}
                                                            tooltip={getTooltipAge(g)}
                                                            nowrap
                                                            size="18" />
                                                    </span>
                                                    {#if g.food_restriction}
                                                        <span class="label">
                                                            <Icon
                                                                name="utensils"
                                                                tooltip={g.food_restriction} />
                                                        </span>
                                                    {/if}
                                                    {#if g.favorite_songs}
                                                        <span class="label">
                                                            <Icon
                                                                name="music"
                                                                tooltip={g.favorite_songs} />
                                                        </span>
                                                    {/if}
                                                    <Spacer />
                                                </HStack>
                                                {#if g.opened}
                                                    <VStack>
                                                        <Label
                                                            icon="utensils"
                                                            copy
                                                            text={g.food_restriction ||
                                                                "Aucune restriction"}
                                                            h="unset" />
                                                        <Label
                                                            icon="music"
                                                            copy
                                                            text={g.favorite_songs ||
                                                                "Pas de chanson favorite"}
                                                            h="unset" />
                                                    </VStack>
                                                {/if}
                                            </section>
                                        </Button>
                                    {/each}
                                </p>
                                <p>Message aux Mariés:</p>
                                <pre>{$message.m.comment || "Aucun message"}</pre>
                            {:else if $message.m.type == "MSG"}
                                <pre>{$message.m.comment || "Aucun message"}</pre>
                            {/if}
                        </VStack>
                    </article>
                    <div class="line" />
                    {#if $invitation.length > 0}
                        <section>
                            <HStack>
                                <img src="/images/invites.svg" alt="guests" width="48px" />
                                <VStack>
                                    <HStack alignment="baseline">
                                        <span>
                                            {`[Invitation] ${$invitation[0].name} <${$invitation[0].email}>`}
                                        </span>
                                    </HStack>
                                    <span>[{$message.m.invitation_code}]</span>
                                </VStack>
                            </HStack>
                        </section>
                        <article>
                            <VStack>
                                <p>
                                    <VStack>
                                        <section
                                            class="group opened"
                                            on:mouseenter={() => (hamburger[0].display = true)}
                                            on:mouseleave={() => (hamburger[0].display = false)}>
                                            <HStack alignment="stretch" grow>
                                                <span class="group">
                                                    <Label
                                                        icon="images/family-restroom.svg"
                                                        fa={false}
                                                        text={$invitation[0].name}
                                                        h="auto" />
                                                </span>
                                                {#if $invitation[0].groupLabels}
                                                    {#each $invitation[0].groupLabels || [] as l (l.id)}
                                                        <span class="label">
                                                            <Label text={l.name} icon="tag" />
                                                        </span>
                                                    {/each}
                                                {/if}
                                                <Spacer />

                                                <Hamburger
                                                    bind:open={hamburger[0].opened}
                                                    left={false}>
                                                    <Button
                                                        action={(e) =>
                                                            handleInvitationLabels(
                                                                e,
                                                                $invitation[0].invitation_id
                                                            )}>
                                                        <Label
                                                            text="Gérer les labels"
                                                            icon="tag"
                                                            h="24px" />
                                                    </Button>
                                                </Hamburger>
                                            </HStack>
                                            <ul class="opened">
                                                <VStack>
                                                    {#each $invitation as g, i (g.id)}
                                                        <section
                                                            class="member"
                                                            on:mouseenter={() =>
                                                                (hamburger[i + 1].display = true)}
                                                            on:mouseleave={() =>
                                                                (hamburger[i + 1].display = false)}>
                                                            <HStack alignment="flex-start" grow>
                                                                <span class="name">
                                                                    {#if g.age == "A"}
                                                                        {#if g.gender == "F"}
                                                                            <Label
                                                                                text="{g.firstname}
                                                                {g.lastname}"
                                                                                tooltip={getTooltipAge(
                                                                                    g
                                                                                )}
                                                                                nowrap
                                                                                size="18"
                                                                                icon="female"
                                                                                iconColor="#FF005C" />
                                                                        {:else}
                                                                            <Label
                                                                                text="{g.firstname}
                                                                {g.lastname}"
                                                                                tooltip={getTooltipAge(
                                                                                    g
                                                                                )}
                                                                                nowrap
                                                                                size="18"
                                                                                icon="male" />
                                                                        {/if}
                                                                    {:else if g.age == "T"}
                                                                        {#if g.gender == "F"}
                                                                            <Label
                                                                                text="{g.firstname}
                                                                {g.lastname}"
                                                                                tooltip={getTooltipAge(
                                                                                    g
                                                                                )}
                                                                                nowrap
                                                                                size="18"
                                                                                fa={false}
                                                                                icon="images/cap_pink.svg"
                                                                                iconColor="#FF005C" />
                                                                        {:else}
                                                                            <Label
                                                                                text="{g.firstname}
                                                                {g.lastname}"
                                                                                tooltip={getTooltipAge(
                                                                                    g
                                                                                )}
                                                                                nowrap
                                                                                size="18"
                                                                                fa={false}
                                                                                icon="images/cap.svg" />
                                                                        {/if}
                                                                    {:else if g.age == "C"}
                                                                        {#if g.gender == "F"}
                                                                            <Label
                                                                                text="{g.firstname}
                                                                {g.lastname}"
                                                                                tooltip={getTooltipAge(
                                                                                    g
                                                                                )}
                                                                                nowrap
                                                                                size="18"
                                                                                icon="child"
                                                                                iconColor="#FF005C" />
                                                                        {:else}
                                                                            <Label
                                                                                text="{g.firstname}
                                                                {g.lastname}"
                                                                                tooltip={getTooltipAge(
                                                                                    g
                                                                                )}
                                                                                nowrap
                                                                                size="18"
                                                                                icon="child" />
                                                                        {/if}
                                                                    {:else if g.age == "B"}
                                                                        {#if g.gender == "F"}
                                                                            <Label
                                                                                text="{g.firstname}
                                                                {g.lastname}"
                                                                                tooltip={getTooltipAge(
                                                                                    g
                                                                                )}
                                                                                nowrap
                                                                                size="18"
                                                                                icon="baby"
                                                                                iconColor="#FF005C" />
                                                                        {:else}
                                                                            <Label
                                                                                text="{g.firstname}
                                                                {g.lastname}"
                                                                                tooltip={getTooltipAge(
                                                                                    g
                                                                                )}
                                                                                nowrap
                                                                                size="18"
                                                                                icon="baby" />
                                                                        {/if}
                                                                    {/if}
                                                                </span>
                                                                <span
                                                                    class="label"
                                                                    class:attending={g.is_attending ===
                                                                        "1"}
                                                                    class:not_attending={g.is_attending ===
                                                                        "0"}>
                                                                    <Label
                                                                        text={g.is_attending === "1"
                                                                            ? "OUI"
                                                                            : "NON"}
                                                                        tooltip={g.is_attending ===
                                                                        "1"
                                                                            ? "Présent"
                                                                            : "Non présent"}
                                                                        icon="glass-cheers"
                                                                        color="inherit"
                                                                        iconColor="inherit" />
                                                                </span>
                                                                {#if g.food_restriction}
                                                                    <span
                                                                        class="label food_restriction">
                                                                        <Icon
                                                                            name="utensils"
                                                                            tooltip={g.food_restriction} />
                                                                    </span>
                                                                {/if}
                                                                {#if g.favorite_songs}
                                                                    <span class="label">
                                                                        <Icon
                                                                            name="music"
                                                                            tooltip={g.favorite_songs} />
                                                                    </span>
                                                                {/if}
                                                                {#each g.labels as l (l.id)}
                                                                    <span class="label">
                                                                        <Label
                                                                            text={l.name}
                                                                            icon="tag" />
                                                                    </span>
                                                                {/each}

                                                                <Hamburger
                                                                    left={false}
                                                                    bind:open={hamburger[i + 1]
                                                                        .opened}
                                                                    display={hamburger[i + 1]
                                                                        .display}>
                                                                    <Button
                                                                        action={() =>
                                                                            editGuest(g.id, i + 1)}>
                                                                        <Label
                                                                            text="Editer"
                                                                            icon="edit"
                                                                            h="24px" />
                                                                    </Button>
                                                                    <Button
                                                                        action={() =>
                                                                            handleLabels(
                                                                                g.id,
                                                                                i + 1
                                                                            )}>
                                                                        <Label
                                                                            text="Gérer les labels"
                                                                            icon="tag"
                                                                            h="24px" />
                                                                    </Button>
                                                                </Hamburger>
                                                                <Spacer />
                                                            </HStack>
                                                        </section>
                                                    {/each}
                                                    {#if !isAddGuest}
                                                        <div class="actions">
                                                            <Button action={addGuest}>
                                                                <Label
                                                                    text="Ajouter un membre à la famille"
                                                                    icon="user-plus"
                                                                    h="48px" />
                                                            </Button>
                                                        </div>
                                                    {/if}

                                                    <GuestForm
                                                        {submit}
                                                        {cancel}
                                                        bind:show={isAddGuest}
                                                        bind:guestId
                                                        bind:firstName
                                                        bind:lastName
                                                        showEmail={false}
                                                        bind:email
                                                        bind:age
                                                        bind:age_val
                                                        bind:gender
                                                        showAttending
                                                        bind:attending
                                                        showFoodRestriction
                                                        bind:food_restriction
                                                        showFavoriteSongs
                                                        bind:favorite_songs
                                                        placeholder={"Email (si différent de l’email principal)"} />
                                                </VStack>
                                            </ul>
                                        </section>
                                    </VStack>
                                </p>
                            </VStack>
                        </article>
                    {/if}
                {/if}
            </content>
        </HStack>
    </Background>
    <Copyright company="KiwisApp" />
</main>

<style>
    .line {
        width: 100%;
        height: 1px;
        border-top: 5px solid var(--primary-light-color);
        margin-bottom: 1em;
    }

    side {
        height: auto;
        width: 500px;
        /* margin-right: 1em; */
        display: flex;
        flex-direction: column;
        max-height: 920px;
        min-height: 200px;
    }
    side > h2 {
        color: var(--on-primary-color);
        margin-left: 10px;
        text-align: center;
    }

    side > section {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-evenly;
        margin: 5px;
    }

    side > div {
        overflow-y: auto;
        overflow-x: hidden;
        background-color: white;
    }
    side article {
        height: 3em;
        border-bottom: 1px solid;
        margin-top: 1em;
        padding: 1em;
        display: flex;
        cursor: pointer;
    }

    side article:hover {
        color: var(--primary-light-color);
    }

    side article:last-of-type {
        border: none;
        height: 0px;
        cursor: normal;
    }

    side article:not(.read) .from {
        font-weight: bold;
    }

    side article.selected {
        background-color: var(--secondary-light-color);
        color: var(--on-primary-color);
    }

    side article .date {
        font-size: smaller;
    }

    content {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-items: stretch;
        justify-content: flex-start;
        width: 100%;
        background-color: white;
    }

    content > section {
        height: 3em;
        padding: 1em;
        margin-bottom: 0;
        margin-left: 0;
        background-color: var(--primary-color);
        color: var(--on-primary-color);
    }

    content article {
        flex-grow: 1;
    }

    content article section.member {
        line-height: 3em;
        border: 1px solid var(--primary-color);
        border-radius: 5px;
        padding-top: 10px;
        padding-left: 5px;
        margin-bottom: 5px;
        height: auto;
    }

    content article section.member:nth-child(even) {
        background-color: #edf4f9;
    }

    content article section.group {
        line-height: 3em;
        border: 1px solid var(--primary-color);
        border-radius: 5px;
        padding-top: 5px;
        margin-bottom: 5px;
        height: 45px;
    }
    content article section.group.opened {
        height: auto;
    }

    content article section.group:nth-child(even) {
        background-color: #edf4f9;
    }

    content article section.member:hover {
        background-color: rgb(244, 245, 247);
        color: rgb(23, 43, 77);
    }

    content article span {
        margin-right: 1em;
    }
    content article span.name {
        line-height: 1em;
        border-radius: 15px;
        background-color: #b8c5d0;
        padding: 0.5em;
        margin-bottom: 5px;
        margin-right: 1em;
    }

    content article span.age {
        line-height: 1em;
        border-radius: 15px;
        background-color: #b8c5d0;
        padding: 0.5em;
        margin-bottom: 5px;
        margin-right: 1em;
    }

    content article span.label {
        line-height: 1em;
        border-radius: 15px;
        background-color: var(--secondary-light-color);
        padding: 0.5em;
        margin-bottom: 5px;
        margin-right: 1em;
    }

    content article span.label.food_restriction {
        background-color: var(--error-color);
        color: var(--on-error-color);
    }

    content article span.label.not_attending {
        background-color: var(--error-color);
        color: var(--on-error-color);
    }

    content article span.label.attending {
        background-color: var(--primary-light-color);
        color: var(--on-primary-color);
    }

    content article span.group {
        line-height: 1em;
        align-self: stretch;
    }
    content article span.group > :global(article) {
        padding: 0.5em;
    }

    content article pre {
        white-space: pre-wrap;
        overflow-wrap: break-word;
        max-width: 900px;
    }

    @media (min-width: 481px) {
        content {
            flex-direction: column;
            padding-left: 1em;
            padding-right: 1em;
        }
    }
</style>
